import { ReactNode } from 'react'
import cn from 'classnames'

import CopyButton from 'components/ui/copy-button'

import styles from './styles.module.scss'

interface ICellValue {
  children: ReactNode
  accent?: boolean
  subinfo?: boolean
  onClick?: () => void
  className?: string
  copyButton?: boolean
  hiddenCopyButton?: boolean
  isCopied?: boolean
  copyButtonClassName?: string
}

const CellValue = ({
  children,
  accent,
  subinfo,
  onClick,
  className,
  isCopied,
  hiddenCopyButton,
  copyButton,
  copyButtonClassName,
}: ICellValue) => (
  <h2
    className={cn(
      styles.value,
      accent && styles.valueTypeAccent,
      subinfo && styles.valueTypeSubinfo,
      copyButton && styles.copyButton,
      className,
    )}
    onClick={onClick}
  >
    {children}
    {copyButton && (
      <CopyButton
        isCopied={isCopied}
        hiddenCopyButton={hiddenCopyButton}
        className={copyButtonClassName}
        messageClassName={styles.message}
      />
    )}
  </h2>
)

export default CellValue
